<template>
    <div class="body">
        <div class="container animate-fade-in">
            <div class="header-box">
                <div class="icon-circle">💡</div>
                <h2 class="title-text">2026年10月专属成长计划</h2>
                <p class="subtitle-text">Personalized Study Plan</p>
            </div>

            <div class="plan-wrapper">
                <div class="plan-card">
                    <div class="scroll-container">
                        <ul class="course-list">
                            <li v-for="(course, index) in allCourses" :key="index" class="course-item">
                                <span class="check-icon">✓</span>
                                <span class="name">{{ course }}</span>
                            </li>
                            <li v-if="allCourses.length === 0" class="empty-state">
                                暂未选择课程，请返回挑选
                            </li>
                        </ul>
                    </div>
                    <div class="scroll-shadow" v-if="allCourses.length > 6"></div>
                </div>
            </div>

            <footer class="footer-section">
                <div class="tip-box">
                    <i class="info-icon">i</i>
                    <p>点击“生成计划”，可建立富学宝典学习计划<br><span>（富学宝典每15天更新一次）</span></p>
                </div>
                <button class="confirm-btn" @click="confirmSubmit">
                    <span>生成计划</span>
                    <div class="btn-glow"></div>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object, required: false },
        selectedMap: {
            type: Object,
            default: () => ({ A: [], B: [], C: [], D: [], E: [], F: [], G: [] })
        }
    },
    computed: {
        allCourses() {
            const map = this.selectedMap || { A: [], B: [], C: [], D: [], E: [], F: [], G: [] };
            return [
                ...(map.A || []),
                ...(map.B || []),
                ...(map.C || []),
                ...(map.D || []),
                ...(map.E || []),
                ...(map.F || []),
                ...(map.G || [])
            ];
        }
    },
    methods: {
        confirmSubmit() {
            const payload = {
                selectedCourses: {
                    A: this.selectedMap.A || [],
                    B: this.selectedMap.B || [],
                    C: this.selectedMap.C || [],
                    D: this.selectedMap.D || [],
                    E: this.selectedMap.E || [],
                    F: this.selectedMap.F || [],
                    G: this.selectedMap.G || []
                },
            };
            const view = { studyPlan: JSON.stringify(payload) };
            this.$emit('submit', view);
        }
    }
}
</script>

<style scoped>
/* 年度报告风格 · 深色成长计划页 */
/* 容器与背景 */
.body {
    position: relative;
    background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26October/bg.png") no-repeat center / cover;
    background-size: 100px 32px, cover;
    background-color: #1a0810;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    font-family: 'PingFang SC', sans-serif;
    color: #2d1505;
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.body * {
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.container {
    position: relative;
    z-index: 2;
    width: 90%;
    max-width: 500px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 6vh 0 4vh;
    box-sizing: border-box;
}

/* 头部 */
.header-box {
    text-align: center;
    margin-bottom: 5px;
}

.icon-circle {
    font-size: 40px;
    margin-bottom: 10px;
    filter: drop-shadow(0 0 14px rgba(74, 158, 255, 0.55));
}

.title-text {
    font-size: 23px;
    /* background: linear-gradient(180deg, #7cc8ff, #4a9eff 55%, #2d7dd6); */
    /* -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent; */
    color: #db6018;
    text-shadow: 
    -1.5px -1.5px 0 #fff,  
     1.5px -1.5px 0 #fff,
    -1.5px  1.5px 0 #fff,
     1.5px  1.5px 0 #fff;
    margin: 0;
    font-weight: 800;
    letter-spacing: 1px;
    filter: drop-shadow(0 2px 6px rgba(210, 209, 209, 0.6));
}

.subtitle-text {
    font-size: 11px;
    color: rgba(45,20,5,0.45);
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-top: 6px;
}

/* 核心滚动区域 */
.plan-wrapper {
    flex: 1;
    min-height: 0;
    margin: 20px 0;
}

/* 计划清单卡片 */
.plan-card {
    background: rgba(255, 245, 230, 0.15);
    backdrop-filter: blur(18px);
    -webkit-backdrop-filter: blur(18px);
    border-radius: 22px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    border: 1px solid rgba(80, 40, 15, 0.2);
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.scroll-container {
    overflow-y: auto;
    padding: 10px 20px;
    scrollbar-width: thin;
    scrollbar-color: rgba(74,158,255,.5) transparent;
}

.course-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.course-item {
    display: flex;
    align-items: center;
    padding: 15px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    animation: fadeIn 0.5s ease both;
}

.course-item:last-child {
    border-bottom: none;
}

.check-icon {
    width: 20px;
    height: 20px;
    background: linear-gradient(135deg, #a8d8ff, #2d7dd6);
    color: #ffffff;
    font-weight: 900;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    margin-right: 15px;
    flex-shrink: 0;
    box-shadow: 0 0 10px rgba(74, 158, 255, 0.45);
}

.name {
    font-size: 15.5px;
    color: rgba(45, 20, 5, 0.85);
    font-weight: 500;
    line-height: 1.4;
    letter-spacing: 0.5px;
}

/* 底部渐变遮罩 */
.scroll-shadow {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 44px;
    background: linear-gradient(to top, rgba(12, 18, 48, 0.92), transparent);
    pointer-events: none;
    border-radius: 0 0 22px 22px;
}

/* 底部操作 */
.footer-section {
    text-align: center;
}

.tip-box {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    margin-bottom: 18px;
}

.info-icon {
    background: rgba(74, 158, 255, 0.18);
    border: 1px solid rgba(74, 158, 255, 0.4);
    color: #4a9eff;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    margin-top: 3px;
    flex-shrink: 0;
}

.tip-box p {
    font-size: 12.5px;
    color: rgba(45, 20, 5, 0.85);
    margin: 0;
    text-align: left;
    line-height: 1.55;
}

.tip-box span {
    color: rgba(45, 20, 5, 0.4);
    font-size: 11px;
}

.confirm-btn {
    position: relative;
    background: linear-gradient(180deg, #a8d8ff 0%, #4a9eff 50%, #2d7dd6 100%);
    color: #ffffff;
    border: none;
    border-radius: 30px;
    padding: 14px 64px;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: 3px;
    cursor: pointer;
    box-shadow: 0 10px 28px rgba(74, 158, 255, 0.4), inset 0 1px 0 rgba(255,255,255,0.5);
    transition: all 0.3s;
    overflow: hidden;
}

.confirm-btn:active {
    transform: scale(0.96);
    box-shadow: 0 5px 14px rgba(74, 158, 255, 0.35);
}

.btn-glow {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.35) 0%, transparent 70%);
    animation: rotateGlow 4s linear infinite;
}

/* 动画 */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes rotateGlow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* PC 适配 */
@media screen and (min-width: 786px) {
    .body {
        background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26October/pcbg.png") no-repeat center / cover;
        background-size: 110px 35px, cover;
        width: 100% !important;
        height: 100vh !important;
        /* padding: 60px 10%;
        border-radius: 0 !important;
        box-shadow: none !important;
        border: none !important; */
    }
    .title-text {
        font-size: 26px;
    }
    .subtitle-text {
        font-size: 14px;
        color: #000;
    }
    .name {
        font-size: 24px;
        color: rgba(45, 20, 5, 0.85);
    }
    .tip-box p{
        font-size: 18px;
    }
    .tip-box span {
        color: #000;
        font-size: 14px;
    }
    .container { width: 500px; padding-top: 12vh; }
    .plan-card { padding: 10px; }
}

.empty-state {
    padding: 20px;
    text-align: center;
    color: rgba(45,20,5,0.45);
    font-style: italic;
}
</style>